// import { combineReducers } from "redux"
import files from "./file"

export default files
